import { render, staticRenderFns } from "./WorkerSkillsInventoryTable.vue?vue&type=template&id=bea79a94&scoped=true&"
import script from "./WorkerSkillsInventoryTable.vue?vue&type=script&lang=js&"
export * from "./WorkerSkillsInventoryTable.vue?vue&type=script&lang=js&"
import style0 from "./WorkerSkillsInventoryTable.vue?vue&type=style&index=0&id=bea79a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea79a94",
  null
  
)

export default component.exports